// Build-time feature scope.
//
// FOURBALL_ONLY strips the app down to ONLY the 4-Ball tournament workflow
// (registration/rosters, qualifying, build, live scoring, leaderboard+brackets,
// TV boards, GPS map, AI assistant, plus Calcutta/Photos/Contests). Everything
// else — Admin Portal landing card, History, the Pro Shop / retail suite,
// non-4-Ball formats, Weather, the Calculator, Demos & Practice — is removed
// (not rendered, not routed — truly gone, not CSS-hidden).
//
// NOTE: VITE_FOURBALL_ONLY=true is set in BOTH .env.mine.local (pbcc-tourney-test)
// AND .env.theirs.local (pbcc-tourney, the club). So FOURBALL_ONLY is NOT a
// test-only flag — it's true on the club too. Live (completetourneylive) leaves
// it unset (stays FULL-featured even on rebuild).
export const FOURBALL_ONLY = import.meta.env.VITE_FOURBALL_ONLY === 'true'

// TRUE only on the TEST site (pbcc-tourney-test). IS_TEST_SITE now gates ONLY
// things that must NEVER reach production: the test PIN (PinGate) and the debug
// vanish tripwire (qeAudit). All UI/feature work uses PBCC_PREMIUM below.
export const IS_TEST_SITE = String(import.meta.env.VITE_FIREBASE_DATABASE_URL || '').includes('pbcc-tourney-test')

// TRUE on the premium PBCC sites — the TEST copy (pbcc-tourney-test), the LIVE
// club site (completetourneylive / pbccgolf.com), AND the big full-featured site
// (yesnetlabs-tourney). Gate for the full premium restyle (gold/cream/deep-green
// theme + 4-Ball feature set). THEIRS (pbcc-tourney, the empty copy) stays
// non-premium. NOTE: yesnetlabs runs the FULL app (FOURBALL_ONLY=false) with the
// premium theme — so premium styling must NOT assume FOURBALL_ONLY.
export const PBCC_PREMIUM =
  String(import.meta.env.VITE_FIREBASE_DATABASE_URL || '').includes('pbcc-tourney-test') ||
  String(import.meta.env.VITE_FIREBASE_DATABASE_URL || '').includes('completetourneylive') ||
  String(import.meta.env.VITE_FIREBASE_DATABASE_URL || '').includes('yesnetlabs-tourney')
